export function getAutoOpenShareLink(links = [], currentUrl = window.location.href) {
    // The user explicitly followed whatever share link is in the URL, so don't hijack
    // them onto a different viewable link: a restricted ?share=def should show its own
    // contact/path options rather than redirect to an unrelated viewable ?share=abc.
    if (hasActiveShareParam(currentUrl)) return undefined
    return links.find((link) => canOpenWithoutLicense(link, currentUrl))
}

function canOpenWithoutLicense(link, currentUrl) {
    return !!(link?.canViewWithoutLicense && link?.url && !isShareLinkAlreadyOpen(link.url, currentUrl))
}

function hasActiveShareParam(currentUrl) {
    try {
        const current = new URL(currentUrl, window.location.origin)
        const currentShare = current.searchParams.get("share")
        return !!currentShare && currentShare !== "clear"
    } catch {
        return false
    }
}

export function isShareLinkAlreadyOpen(linkUrl, currentUrl = window.location.href) {
    try {
        const current = new URL(currentUrl, window.location.origin)
        const target = new URL(linkUrl, current.origin)
        const currentShare = current.searchParams.get("share")
        const targetShare = target.searchParams.get("share")
        return !!targetShare && targetShare !== "clear" && currentShare === targetShare
    } catch {
        return false
    }
}
